import Swiper from 'swiper';

export default sliderDestinations => {
    // console.log('sliderDestinations');
    const swiperContainerProducts = sliderDestinations.querySelector('.swiper-container');
    const dataSimulateTouch = sliderDestinations.getAttribute('data-swiper-simulateTouch');
    const dataGrabCursor = sliderDestinations.getAttribute('data-swiper-grabCursor');

    const destinationsSlider = new Swiper(swiperContainerProducts, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: !(dataGrabCursor !== null && dataGrabCursor === 'false'),
        simulateTouch: !(dataSimulateTouch !== null && dataSimulateTouch === 'false'),
        breakpoints: {
            576: {
                spaceBetween: 10,
            },
            768: {
                spaceBetween: 10,
            },
            992: {
                spaceBetween: 30,
            },
            1200: {
                spaceBetween: 30,
            },
            1370: {
                spaceBetween: 30,
            },
        },
    });
};
